import { PayPalScriptProvider, PayPalButtons, FUNDING, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { t } from "@/lib/i18n";

const Buttons = ({ pkg, props }) => {
  const [{ isPending, isRejected }] = usePayPalScriptReducer();
  if (isRejected) return <p className="text-xs text-red-600" data-testid="paypal-load-error">{t("Payments are not configured yet")}</p>;
  if (isPending) return <p className="text-xs text-slate-500">{t("LOADING…")}</p>;
  return (
    <>
      <PayPalButtons {...props} fundingSource={FUNDING.PAYPAL} forceReRender={[pkg]} />
      <PayPalButtons {...props} fundingSource={FUNDING.CARD} forceReRender={[pkg]} />
    </>
  );
};

export const PayPalCheckout = ({ clientId, pkg, onPaid }) => {
  const createOrder = async () => {
    try {
      const { data } = await api.post("/payments/paypal/create", { package_id: pkg, origin_url: window.location.origin });
      return data.order_id;
    } catch (e) { toast.error(errMsg(e)); throw e; }
  };
  const onApprove = async ({ orderID }) => {
    try {
      const { data } = await api.post(`/payments/paypal/capture/${orderID}`);
      if (data.payment_status === "paid") { toast.success(t("Payment received · credits added")); onPaid(); }
      else toast.error(t("Payment was not completed"));
    } catch (e) { toast.error(errMsg(e)); }
  };
  const props = { createOrder, onApprove, onError: () => toast.error(t("Payment failed, please try again")), style: { layout: "vertical", shape: "rect", label: "pay" } };

  return (
    <PayPalScriptProvider options={{ clientId, currency: "USD", intent: "capture", components: "buttons", enableFunding: "card" }}>
      <div data-testid={`paypal-buttons-${pkg}`} className="space-y-2">
        <Buttons pkg={pkg} props={props} />
      </div>
    </PayPalScriptProvider>
  );
};
